import styled from "styled-components";

export const CommonTableWrap = styled.div`
  min-width: 0;

  .ant-table-tbody > tr > td,
  .ant-table-tbody-virtual .ant-table-cell {
    height: auto;
    padding-top: 0;
    padding-bottom: 0;
  }
`;
